import { NgModule, ModuleWithProviders } from '@angular/core';

import { IgoSharedModule } from '../shared';

import { ImportExportComponent } from './import-export';
import { ImportExportService, DropGeoFileDirective } from './shared';


@NgModule({
  imports: [
    IgoSharedModule
  ],
  exports: [
    ImportExportComponent,
    DropGeoFileDirective
  ],
  declarations: [
    ImportExportComponent,
    DropGeoFileDirective
  ]
})
export class IgoImportExportModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: IgoImportExportModule,
      providers: [
        ImportExportService
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/import-export/module.ts